<template>
  <div
    ref="root"
    class="flex flex-col justify-start overflow-hidden"
    :class="hasMounted ? '' : 'h-0'"
  >
    <div ref="inner" class="w-full">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface CollapsibleWrapperProps {
  collapse?: boolean
  fade?: boolean
}

const props = withDefaults(defineProps<CollapsibleWrapperProps>(), {
  collapse: false,
  fade: false,
})
const root = ref<HTMLDivElement | null>(null)
const inner = ref<HTMLDivElement | null>(null)
const hasMounted = ref(false)

const { $anime } = useNuxtApp()

onMounted(() => {
  if (props.collapse && root.value) {
    $anime.set(root.value, { height: 0 })
  }

  hasMounted.value = true

  watch(props, ({ collapse }) => {
    if (root.value && inner.value) {
      const height = parseInt(`${$anime.get(inner.value, 'height')}`, 10)
      const duration = Math.max(750, height * 1.25)

      const options = {
        targets: root.value,
        height: collapse ? 0 : [0, height],
        opacity: {},
        translateZ: 0,
        duration,
        easing: slideEasing,
        complete() {
          if (!collapse) {
            root.value!.style.height = ''
          }
        },
      }

      if (props.fade) {
        options.opacity = {
          value: collapse ? 0 : [0, 1],
          delay: collapse ? 0 : duration * 0.3,
        }
      }

      $anime(options)
    }
  })
})
</script>
